import { useEffect, useState } from "react";
import { useGetRevenueAnalysticEachStoreApi } from "../../hooks";
import StatisticalRightItem from "./StatisticalRightItem";
import { useAccountStore, useRevenueAnalysticEachStore } from "../../store";
import { Select, Spin } from "antd";
import { useRevenueStoreAnalystic } from "../../store/revenue/revenue.store.analystic.store";
import { getStartEndOfAnyMonth } from "../../helper";
import empty from "../../assets/empty.png";
import { LoadingOutlined } from "@ant-design/icons";

const listMonth = [
  { value: 1, label: "January (1)" },
  { value: 2, label: "February (2)" },
  { value: 3, label: "March (3)" },
  { value: 4, label: "April (4)" },
  { value: 5, label: "May (5)" },
  { value: 6, label: "June (6)" },
  { value: 7, label: "July (7)" },
  { value: 8, label: "August (8)" },
  { value: 9, label: "September (9)" },
  { value: 10, label: "October (10)" },
  { value: 11, label: "November (11)" },
  { value: 12, label: "December (12)" },
];

const listYear = [
  { value: 2023, label: "2023" },
  { value: 2024, label: "2024" },
  { value: 2025, label: "2025" },
  { value: 2026, label: "2026" },
];

const StatisticalRight = () => {
  const [listData, setListData] = useState([]);
  const [isLoaded, setIsLoaded] = useState(true);

  const currentDate = new Date();
  const yearCurrent = currentDate.getFullYear();
  const monthCurrent = currentDate.getMonth();

  const { revenueAnalysticEachStore, isLoading } =
    useGetRevenueAnalysticEachStoreApi();

  const { monthSelect, setMonthSelect, setYearSelect, yearSelect } =
    useRevenueStoreAnalystic();

  const { month, setAccountId, setMonth, setYear, setMonthBefore, year } =
    useRevenueAnalysticEachStore();

  const { end: endDayOfMonth, start: startDayOfMonth } = getStartEndOfAnyMonth(
    yearCurrent,
    monthSelect ?? monthCurrent
  );

  useEffect(() => {
    if (info?.role && info?.role === "ROLE_ADMIN") {
      setAccountId(undefined);
    } else if (info?.role && info?.role === "ROLE_INVERTOR") {
      setAccountId(info?.id);
    }
    setMonthSelect(monthSelect ? monthSelect : monthCurrent);
  }, [yearCurrent, monthCurrent, startDayOfMonth, endDayOfMonth]);

  // info
  const { info } = useAccountStore();

  useEffect(() => {
    setYear(yearCurrent);
    if (!month) {
      setMonth(monthCurrent);
    }
    if (info?.role && info?.role === "ROLE_ADMIN") {
      setAccountId(undefined);
    } else if (info?.role && info?.role === "ROLE_INVERTOR") {
      setAccountId(info?.id);
    }
    if (month > 1) {
      setMonthBefore(month - 1);
    } else setMonthBefore(1);

    if (
      revenueAnalysticEachStore?.code === 200 &&
      revenueAnalysticEachStore?.data
    ) {
      setIsLoaded(false);
      setListData(revenueAnalysticEachStore?.data);
      setIsLoaded(true);
    }
  }, [isLoading, monthCurrent, yearCurrent, month, monthSelect]);

  return (
    <div className="w-full">
      <div className="flex items-center justify-between pb-3 border-b-[1px]">
        <div className="w-full">
          <h3 className="font-semibold text-gray-800 text-base tracking-wider">
            Overall Status Of Store
          </h3>
          <span className="text-gray-700 text-sm max-sm:text-[12px]">
            Overall Status Of Store All PhotoTime VietNam
          </span>
          <div className="mt-1 flex items-center xl:gap-6 gap-4 w-full">
            <Select
              defaultValue={monthSelect ? monthSelect : monthCurrent}
              // style={{ width: 100 }}
              className="w-1/2"
              allowClear
              onChange={(e) => {
                setMonthSelect(e);
                // if (reload) {
                //   setReload(false);
                // } else {
                //   setReload(true);
                // }
              }}
              options={listMonth}
              placeholder="select it"
            />

            <Select
              defaultValue={yearSelect ? yearSelect : yearCurrent}
              className="w-1/2"
              allowClear
              onChange={(e) => {
                setYearSelect(e);
                // if (reload) {
                //   setReload(false);
                // } else {
                //   setReload(true);
                // }
              }}
              options={listYear}
              placeholder="select it"
            />
          </div>
        </div>
      </div>
      <div className="lg:mt-4 mt-2 custom-scrollbar px-[8px] rounded-xl h-[40vh] xl:h-[60vh] flex flex-col gap-2 overflow-y-auto">
        {isLoading ? (
          <div className="w-full h-full flex justify-center mt-6">
            <Spin indicator={<LoadingOutlined spin />} />
          </div>
        ) : listData?.length > 0 ? (
          listData?.map((item) => {
            // add key for item
            return <StatisticalRightItem data={item}></StatisticalRightItem>;
          })
        ) : (
          <div className="w-full h-full flex justify-center items-center">
            <img className="w-1/2" src={empty}></img>
          </div>
        )}
      </div>
    </div>
  );
};

export default StatisticalRight;
